import Collapse from "bootstrap/js/src/collapse"
// toggles nested bs collapse

// collapse-all
// example:
// <div data-controller="collapse-all">
//   <button data-action="collapse-all#expand" type="button">expand all</button>
//   <button data-action="collapse-all#collapse" type="button">collapse all</button>
//   <a data-bs-toggle="collapse" href="#" role="button" aria-expanded="false" aria-controls="collapse1">toggle</a>
//   <div class="collapse" id="collapse1" data-collapse-all-target="collapse">text</div>
//   <a data-bs-toggle="collapse" href="#" role="button" aria-expanded="false" aria-controls="collapse2">toggle</a>
//   <div class="collapse" id="collapse2" data-collapse-all-target="collapse">text</div>
// </div>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "collapse" // element with `.collapse`
  ]

  expand(e) {
    e.preventDefault()
    this.collapseTargets.forEach(element => {
      Collapse.getInstance(element).show()
    });
  }

  collapse(e) {
    e.preventDefault()
    this.collapseTargets.forEach(element => {
      Collapse.getInstance(element).hide()
    });
  }
}
